import type { ISessionRepository, SessionExportEntity, SessionExportOptions } from '../repositories/ISessionRepository.js';

interface Deps { sessionRepository: ISessionRepository; }

export function createExportSessionsUseCase({ sessionRepository }: Deps) {
  return async function exportSessions(options: SessionExportOptions): Promise<SessionExportEntity[]> {
    return sessionRepository.exportByProject(options);
  };
}
